import { createContext, useContext } from "react";

export const DetailContext = createContext<any | undefined>(undefined);

export function useDetail() {
  return useContext(DetailContext);
}
